/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import Asset, {
  Rendition
} from '../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../magnolia/lib/MagnoliaPropertyHelper';

export interface switchableStruct {
  field ? : string;
  page ? : any;
  inLinkParam ? : string;
  external ? : string;
}
export default interface Redirect {
  status ? : string;
  switchable ? : switchableStruct;
  metadata ? : any;
}

export const Props = {
  status: String,
  switchable: Object as() => switchableStruct,
  metadata: Object,
}

export const WrapperProps = {
  status: String,
  switchable: Object as() => switchableStruct,
  metadata: Object,
}

export class RedirectBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class RedirectInstance implements Redirect {
      status ? : string;
      switchable ? : switchableStruct;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

      }
    }
    return new RedirectInstance(props);
  }
}
